import { useState, useRef, useEffect } from "react";
import { User } from "../../types";
import { PAGES_ENDPOINTS } from '../../config/api';
import { Button } from "../common/Button";
import { userNameWithInitial } from "../../api";
import { useNavigate } from "react-router-dom";

interface UserDropdownProps {
  user: User | null;
  onLogout: () => void;
}

export const UserDropdown: React.FC<UserDropdownProps> = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Chiude il dropdown se clicchi fuori
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const renderDropdown = () => {
    const username = user ? userNameWithInitial(user) : "Utente"; // Default se user è null
    return <>
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 rounded-md"
        variant="primary"
        isOutlined={true}
        size="lg"
      >
        {username}
        <svg
          className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </Button>
    </>
  }

  return (
    <div className="relative" ref={dropdownRef}>
      {user ? renderDropdown() : (
        <Button 
          onClick={() => navigate(PAGES_ENDPOINTS.LOGIN)} 
          variant="primary" isOutlined={true} size="lg"
        >
          Login
        </Button>
      )}

      {isOpen && (
        <div className="absolute right-0 mt-2 w-44 rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-20">
          <div className="py-1 flex flex-col">
            <Button
              onClick={() => {
                setIsOpen(false)
                navigate(PAGES_ENDPOINTS.USER_PROFILE)
              }}
              variant="ghost"
              size="lg"
            >
              Profilo
            </Button>
            <Button
              onClick={() => {
                setIsOpen(false);
                onLogout();
              }}
              variant="ghost"
              size="lg"
            >
              Logout
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
